
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.711 5.389a.9.9 0 111.8 0 .9.9 0 01-1.8 0zm.9-2.4a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zM4.49 18.61a.9.9 0 111.8 0 .9.9 0 01-1.8 0zm.9-2.4a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zm13.222 1.5a.9.9 0 100 1.8.9.9 0 000-1.8zm-2.4.9a2.4 2.4 0 114.8 0 2.4 2.4 0 01-4.8 0zM4.49 5.39a.9.9 0 111.8 0 .9.9 0 01-1.8 0zm.9-2.4a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zm0 5.461a.75.75 0 01.75.75v5.6a.75.75 0 01-1.5 0V9.2a.75.75 0 01.75-.75zM9.2 4.639a.75.75 0 000 1.5h5.6a.75.75 0 000-1.5H9.2zm-.75 13.973a.75.75 0 01.75-.75h5.6a.75.75 0 110 1.5H9.2a.75.75 0 01-.75-.75zM19.361 9.2a.75.75 0 00-1.5 0v5.6a.75.75 0 001.5 0V9.2z"}})])
          )
        }
      }
    